export const environment = {
  // Keycloak
  keycloakUrl: 'https://auth.test123.nl',
  keycloakRealm: 'wander-and-wonder',
  keycloakClientId: 'stichting-wijkcollectie',
  // API
  apiUrl: 'https://swc-cms-api.test123.nl'
};
